export const MASS_DE_PSEUDO_SUCCESS = 'MASS_DE_PSEUDO_SUCCESS';

export const massDePseudoSuccess = (careProviders, resultIds) => ({
    type: MASS_DE_PSEUDO_SUCCESS,
    payload: { careProviders, resultIds },
});